import { render, staticRenderFns } from "./itemDyn.vue?vue&type=template&id=304b16c4"
import script from "./itemDyn.vue?vue&type=script&lang=js"
export * from "./itemDyn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports